export interface ProductSpecPrint {
  id: string;
  key: string;
  description: string;
  productType: string;
  customerName: string;
  comments: string;
  imagePath: string;
  imagePath2: string;
  stdRollLength: number;
  aveRollLength: number;
  smallestReusable: number;
  conversionFactor: number;
  length: number;
  width: number;
  fabricDescription: string;
  fabricRequired: number;
  cushionPad1: string;
  cushionPad2: string;
  trimDescription: string;
  zipColour: string;
  trimDescriptionDescription: string;
  labelPlacementDescription: string;
  brandLabelDescription: string;
  careLabelDescription: string;
  minimumOrderQuantity: number;
  usableWidth: number;
  horizontalRepeat: string;
  verticalRepeat: string;
  ratings: number;
  gms: string;
  glm: number;
  composition: string;
  verticalPatternRepeat: string;
  horizontalPatternRepeat: string;
  patternMatch: string;
  reMeasureLevel: number;
  standardRollLength: number;
  smallestReusableLength: number;
  acceptableWastage: number;
  standardSampleCutLength: number;
  careInstructions: string;
  gramsPerSquareMeterRange: string;
  printedWeight: string;
  micronSize: number;
  micronCode: string;
  maxLength: number;
  origin: string;
  colour: string;
  bespokeSample: string;
  sampleType: string;
  kgsPerMtr2: number;
  size: string;
  label: string;
  count: number;
  countSystem: string;
  countDescription: string;
  twistTurns: number;
  twistDescription: string;
  ply: number;
}
